import {
  ButtonGroup,
  BasicButton,
  PrimaryButton,
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { Form } from "formik";
import { Trans } from "react-i18next";

export function FormModal(props: {
  title: string;
  children: React.ReactNode;
  onClose?: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  continueText?: string;
  secondaryText?: string;
  variant?: "success" | "danger";
  testID?: string;
}) {
  return (
    <Modal testID={props.testID}>
      <Dialog width={560}>
        <DialogHeader
          onClose={props.onClose ? props.onClose : props.onCancel}
          testID={`${slugify(props.title)}-modal-header`}
        >
          {props.title}
        </DialogHeader>
        <DialogContent testID={`${slugify(props.title)}-modal-content`}>
          <Form>{props.children}</Form>
        </DialogContent>
        <DialogFooter testID={`${slugify(props.title)}-modal-footer`}>
          <ButtonGroup>
            <BasicButton
              size="medium"
              onPress={props.onCancel}
              testID={`${slugify(props.title)}-cancel-button`}
            >
              {props.secondaryText ?? <Trans>Cancel</Trans>}
            </BasicButton>
            <PrimaryButton
              testID={`${slugify(props.title)}-${
                slugify(props.continueText) || slugify("continue")
              }-button`}
              size="medium"
              onPress={props.onSubmit}
              variant={props.variant ?? "danger"}
            >
              {props.continueText ?? <Trans>Continue</Trans>}
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
